// extracted by mini-css-extract-plugin
module.exports = {"popup":"ProcessPopup_popup__kfO24","header":"ProcessPopup_header__3Nx_I"};